<div class="modal-clean modal-clean--wide modal-cancel-subscription --centered">
    <div class="modal-clean__content --no-outer-padding" #container>
        <div class="modal-clean__header">
            <div *ngIf="activeSection !== 'finish'" class="modal__close --back" (click)="previousSection()"></div>
            <div *ngIf="activeSection == 'finish'" class="modal__close" (click)="close()"></div>
            <div class="modal__title">Cancel Ad-Free Experience?</div>
        </div>
        <div class="modal-cancel-subscription__container" *ngIf="activeSection == 'benefits'">
            <div class="modal-cancel-subscription__container__title">
                You and the people you call will see ads when using Together.
            </div>
            <div class="modal-cancel-subscription__container__banner">
                <img src="/assets/images/ads-cancel-banner.png" class="modal-cancel-subscription__container__image" />
            </div>
            <ng-container>
                <div class="features-box" *ngIf="subscribedTier">
                    <div class="features-box__title">
                        The Together catalogue will still be free with ads, including:
                    </div>
                    <div class="features-box__features__item" *ngFor="let feature of subscribedTier.contentIncluded">
                        <span class="__icon">✓</span>
                        <span class="__text"
                            ><span class="--highlight">{{ feature.value }}</span> {{ feature.label }}</span
                        >
                    </div>
                </div>
            </ng-container>
            <div class="showcase-footer">
                <button class="button-v2 --purple --medium --wide --rounded" (click)="close()">
                    Keep my subscription
                </button>
                <div class="action-link" (click)="nextSection()">Continue to cancel</div>
            </div>
            <ng-template #loadingView>
                <div class="loading-animation">
                    <ng-lottie [options]="animation"></ng-lottie>
                </div>
            </ng-template>
        </div>
        <div class="modal-cancel-subscription__container" *ngIf="activeSection == 'cancel_survey'">
            <div class="modal-cancel-subscription__container__title">Please take a moment to help us improve.</div>
            <div class="feedback__container">
                <form
                    *ngIf="cancelSurveyForm"
                    class="form"
                    [formGroup]="cancelSurveyForm"
                    autocomplete="false"
                    spellcheck="false">
                    <div class="feedback__row">
                        <label class="feedback__label" for="feedback">Why are you canceling your subscription?</label>
                        <textarea
                            id="reason"
                            placeholder="Enter your answer here"
                            formControlName="reason"
                            autocorrect="off"
                            autocapitalize="none"
                            autocomplete="off"></textarea>
                    </div>
                    <div class="feedback__row">
                        <label class="feedback__label" for="feedback">What can we do better?</label>
                        <textarea
                            id="feedback"
                            placeholder="Enter your answer here"
                            formControlName="feedback"
                            autocorrect="off"
                            autocapitalize="none"
                            autocomplete="off"></textarea>
                    </div>
                </form>
            </div>
            <div class="action-container">
                <button
                    class="button-v2 --purple --large --wide --rounded"
                    (click)="submitSurvey()"
                    [disabled]="!cancelSurveyForm.valid">
                    Submit and Cancel
                </button>
                <div class="action-link" (click)="close()">Keep Together</div>
            </div>
        </div>
        <div class="modal-cancel-subscription__container" *ngIf="activeSection == 'finish'">
            <div class="confirmation-container">
                <div class="confirmation-container__image">
                    <img src="/assets/images/crying-red-panda.png" />
                </div>
                <div class="confirmation-container__title">We’re sad to see you go!</div>
                <div class="confirmation-container__content" *ngIf="isAndroid">
                    To finish canceling, go to your device settings and deactivate your subscription. You can still
                    access a limited version of Together for free.
                </div>
                <div class="confirmation-container__content" *ngIf="!isAndroid">
                    To finish canceling, go to the cancelation page and deactivate your subscription. You can still
                    access a limited version of Together for free.
                </div>
            </div>
            <div class="action-container">
                <button class="button-v2 --purple --large --wide --rounded" (click)="openManageSubscription()">
                    {{ isAndroid ? 'Go to Settings' : 'Go to Cancelation' }}
                </button>
            </div>
        </div>
    </div>
</div>
